import React from 'react';
import styled from 'styled-components';
import axios from 'axios';
import ContactForm from './ContactForm';

const Container = styled.div`
  .back {
    background-color: #f7f7f7;
  }
  .section {
    margin-top: 1rem;
  }
  .columns {
    margin: 0rem !important;
    padding: 0rem !important;
  }
  h3:hover {
    color: red;
  }
  .check {
    color: brown;
  }
  .extra {
    height: 13rem;
  }
  .edit {
    padding-top: 2rem;
  }
  .edit2 {
    padding: 4rem;
  }
  .name {
    margin-top: 2rem;
  }
  .msg {
    margin-top: 1rem;
    padding-bottom: 2rem;
  }
  .send {
    margin-top: 2rem;
    font-size: small;
  }
  .icon {
    margin-left: 1rem !important;
  }
  .button:hover {
    background-color: #ff3860;
    color: white;
  }
  .column {
  }
`;
const Extra = () => {
  const handleSubmit = async val => {
    await axios
      .post('https://pick-my-laundry.vercel.app/api/contact', {
        name: val.name,
        phone: val.phone,
        message: val.message,
      })
      .then(function(response) {
        console.log('response', response);
        alert('Submit successfully!', 'We will connect you soon.');
      })
      .catch(function(error) {
        console.log('error', error);
        alert('Error!', error.message);
      });
  };
  return (
    <Container>
      <section className="section">
        <h3 className="column is-7 is-offset-2 has-text-weight-bold is-size-4 has-text-centered">
          {' '}
          CONTACT US
        </h3>
      </section>
      <div className="columns">
        <div className="column is-5">
          <img src="/images/contact-img.jpg" alt="contacts" />
        </div>
        <div className="column is-4 is-offset-1">
          <h1 className="has-text-black is-size-2 has-text-weight-bold has-text-danger">
            Get in touch
          </h1>
          <p className="send has-text-left has-text-weight-semibold">
            we'd love to hear from you.Send a message and we'll respond as soon
            as possible
          </p>
          <ContactForm handleFormSubmit={handleSubmit} />
          {/* <form onSubmit={handleSubmit}>
            <div className="field">
              <div className="control name">
                <input
                  className="input"
                  type="text"
                  placeholder="Your Name"
                  required
                  value={data?.name}
                  onChange={e => setData({ ...data, name: e.target.value })}
                  id="name"
                />
              </div>
            </div>
            <div className="field">
              <div className="control">
                <input
                  className="input"
                  type="text"
                  placeholder="Mobile Number"
                  required
                  id="phone"
                  value={data?.phone}
                  onChange={e => setData({ ...data, phone: e.target.value })}
                />
              </div>
            </div>
            <div className="field">
              <div className="control msg">
                <textarea
                  className="textarea"
                  placeholder="Message"
                  required
                  id="message"
                  value={data?.message}
                  onChange={e => setData({ ...data, message: e.target.value })}
                />
              </div>
            </div>

            <div className="buttons has-addons is-right">
              <your embutton type="submit" className="button is-rounded">
                CONFIRM BOOKING
                <i className="fas fa-long-arrow-alt-right icon" />
              </your>
            </div>
          </form> */}
        </div>
      </div>
    </Container>
  );
};

export default Extra;
